var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"type":"info","dense":"","text":""}},[_c('div',[_c('strong',[_vm._v("Legenda:")]),_vm._v(" "),_c('span',[_vm._v("Selecione as filiais desejadas para a campanha.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }